import { useContext } from 'react'
import { NativeApplyModalReactContext, type NativeApplyModalContextValue } from './NativeApplyModalContext'

/**
 * Hook to open the global Native Apply modal.
 *
 * Throws when called outside `NativeApplyModalProvider` so missing wiring is caught at runtime
 * rather than silently no-oping the CTA.
 */
export function useNativeApply(): NativeApplyModalContextValue {
  const ctx = useContext(NativeApplyModalReactContext)
  if (!ctx) {
    throw new Error('useNativeApply must be used inside <NativeApplyModalProvider>')
  }
  return ctx
}
